import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { is3DModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { InterfaceFactoryOptions } from '../../elements/factory-options.interface';

// 检查是否需要渲染 wordArt
export function checkShouldRenderWordArt(factoryOptions: InterfaceFactoryOptions<IShapeModel>): boolean {
    const prst = factoryOptions.model.textBodyStyle?.bodyStyle?.prstTxWarp?.prst;

    if (prst === undefined) return false;

    const isRealWordArt = prst > 1 && prst < 42;

    const notSupportPrstArr = [10, 11, 12, 13, 17, 32, 33];
    const isSupportPrst = !notSupportPrstArr.includes(prst);

    const textDirection = factoryOptions.model.textBodyStyle?.wrapperStyle?.textDirection || 'horz';
    const notSupportTextDirectionArr = [
        'eaVert',
        'vert',
        'vert270',
        'wordArtVertRtl',
        'wordArtVert',
        'wordArtVertGeneral',
    ];
    const isSupportTextDirection = !notSupportTextDirectionArr.includes(textDirection);

    const notSupportModelArr = [is3DModel];
    const isSupportModel = !notSupportModelArr.some(judge => judge(factoryOptions.model));

    return isRealWordArt && isSupportPrst && isSupportTextDirection && isSupportModel;
}
